import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Route } from 'react-router-dom'
import actions from '../../redux/actions'
import PropTypes from 'prop-types'
import { parse } from 'qs'

import StandardLandingHeader from 'components/header/landing/standard/standard_landing_header'

import CSSModules from 'react-css-modules'
import styles from './signup_base.scss'
import Redirection from 'decorators/authentication/Redirection'
import { signupSelectors } from 'redux/selectors'
import SignUpSSO from './sso/signup_sso'
import SignupMainUnified from './main/signup_main_unified'

class SignupBase extends Component {

	componentDidMount() {
		const params = parse(location.search.substr(1))
		this.props.actions.signUpInitialize(location.search, params)
	}

	render() {
		if (this.props.isUserLogged) {
			return null
		}
		return (
			<div styleName='wrapper'>
				<div styleName='header'>
					<StandardLandingHeader linkHome={this.props.canLinkToHome} />
				</div>
				<div styleName='content'>
					<Route path={`${this.props.match.path}/`} exact component={SignupMainUnified} />
					<Route path={`${this.props.match.path}/sso`} exact component={SignUpSSO} />
					<Route path={`${this.props.match.path}/google`} component={SignUpSSO} />
					<Route path={`${this.props.match.path}/office`} component={SignUpSSO} />
					<Route path={`${this.props.match.path}/clever`} component={SignUpSSO} />
					<Route path={`${this.props.match.path}/classlink`} component={SignUpSSO} />
				</div>
			</div>
		)
	}

}

SignupBase.propTypes = {
	children: PropTypes.element,
	actions: PropTypes.object,
	isUserLogged: PropTypes.bool,
}

SignupBase.defaultProps = {
	isUserLogged: false,
}


function mapStateToProps(state) {
	return signupSelectors.signupBase(state)
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch),
	}
}

export default Redirection(connect(mapStateToProps, mapDispatchToProps)(CSSModules(SignupBase, styles, {allowMultiple: true})))
